import { de } from './de'
import type {
  MessageParams,
  TranslatableError,
  TranslatableIssue,
  Translations,
} from './error-messages.types'
import { fr } from './fr'
import { hu } from './hu'

export type { ErrorMessageKey } from './en'
export { en } from './en'
export type * from './error-messages.types'

const DICTIONARIES: Record<string, Translations> = { de, fr, hu }

/** Languages with translations of backend messages (English is the source). */
export const ERROR_MESSAGE_LOCALES = ['en', ...Object.keys(DICTIONARIES)]

function fill(template: string, params: MessageParams = {}) {
  return template.replace(/\{(\w+)\}/g, (all, k: string) =>
    k in params ? String(params[k]) : all,
  )
}

/**
 * The message of `key` in `locale`, filled with `params`; `fallback` (the
 * English text the server sent) when the key has no translation.
 */
export function translateMessage(
  locale: string,
  key: string | undefined,
  params: MessageParams | undefined,
  fallback: string,
): string {
  if (!key) return fallback
  const dict = DICTIONARIES[locale] ?? DICTIONARIES[locale.split('-')[0]]
  const template = dict?.[key as keyof Translations]

  return template ? fill(template, params) : fallback
}

/** Error envelope message in the user's language (ADR-045). */
export function translateError(
  locale: string,
  error: TranslatableError,
): string {
  return translateMessage(locale, error.messageKey, error.params, error.message)
}

/** Field issue message in the user's language. */
export function translateIssue(
  locale: string,
  issue: TranslatableIssue,
): string {
  return translateMessage(locale, issue.code, issue.params, issue.message)
}
